import SalesQuotesAdd from './SalesQuotesAdd'

export default SalesQuotesAdd
